angular.
module("dx.webapp.student").
constant("DX_EXTENDED_TIME_SETTING", Object.freeze({
	NONE: 0,
	PERCENT: 1,
	LIMITLESS: 2,
}));
